import React from "react";

import { MenuItem } from "../../types/system/MenuItem";
import MainMenuItem from "./MainMenuItem";

interface MenuCollectionProps {
    items: MenuItem[];
    selected: MenuItem;
    collapsed: boolean;
    menuItemClicked: Function;
}

interface MenuCollectionState {}

class MainMenuCollection extends React.Component<
    MenuCollectionProps,
    MenuCollectionState
> {
    state = {};

    menuItemClicked(item: MenuItem) {
        this.props.menuItemClicked(item);
    }

    render() {
        return (
            <ul className="children">
                {this.props.items.map(
                    item =>
                        !item.hidden && (
                            <MainMenuItem
                                key={item.id}
                                item={item}
                                selected={this.props.selected}
                                collapsed={this.props.collapsed}
                                menuItemClicked={item =>
                                    this.props.menuItemClicked(item)
                                }
                            />
                        ),
                )}
            </ul>
        );
    }
}

export default MainMenuCollection;
